import styled from "styled-components";

import InputError from "../../../styles/input/InputError.styled";
import InputLabel from "../../../styles/input/InputLabel.styled";
import NativeDatePicker from "./NativeDatePicker.styled";

interface StyledDatePickerProps {
  direction: "ltr" | "rtl";
}

const StyledDatePicker = styled.div<StyledDatePickerProps>`
  position: relative;

  ${InputLabel} {
    position: ${({ theme }) =>
      theme.pickerLabelAbsolutePosition ? "absolute" : "initial"};
    left: ${({ theme, direction }) =>
      direction === "ltr" ? theme.pickerLabelLeft : "initial"};
    right: ${({ theme, direction }) =>
      direction === "rtl" ? theme.pickerLabelLeft : "initial"};
    top: ${({ theme }) => theme.pickerLabelTop};
  }

  ${NativeDatePicker} {
    width: 100%;
  }

  ${InputError} {
    margin-top: 4px;
  }
`;

export default StyledDatePicker;
